import { createFileRoute } from '@tanstack/react-router';
import { MyGigsPage } from '../components/gigs/my-gigs/MyGigsPage';
import type { MyGigsTab } from '../components/gigs/my-gigs/types';

const VALID_TABS: MyGigsTab[] = ['inquiries', 'applicants', 'offers', 'payment_history'];

export type MyGigsSearch = {
  tab?: MyGigsTab;
};

export const Route = createFileRoute('/profile/my-gigs')({
  component: MyGigsPage,
  validateSearch: (search: Record<string, unknown>): MyGigsSearch => {
    const tab = typeof search.tab === 'string' ? search.tab : undefined;
    return {
      tab: tab && VALID_TABS.includes(tab as MyGigsTab) ? (tab as MyGigsTab) : undefined,
    };
  },
});
